import { Link, useParams } from "react-router-dom";

export default function LogoBar() {
    const { lang } = useParams();
    const baseRoute = `/${lang || "id"}`;
    return (
        <Link
            to={baseRoute || "/id"}
            className="flex items-center gap-2 font-serif text-2xl font-bold group">
            <img
                src="/assets/icons/logo-2.webp"
                alt="Omah Ring"
                className="h-10 w-auto mr-2 rounded-full object-contain transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-gold hidden  md:inline">Omah</span>
            <span className="text-dark dark:text-white hidden md:inline">
                Ring
            </span>
        </Link>
    );
}
